<script>
  import { createEventDispatcher } from 'svelte';
  import { Button } from 'carbon-components-svelte';
  import Time16 from 'carbon-icons-svelte/lib/Time16';
  import isEmpty from 'lodash/isEmpty';

  import { formatDurationUnitsToText } from '../../../../utils';

  export let feedMetadata = {},
    entitlementMetadata = {},
    entitlementId,
    feedName,
    isEditable = true;

  const dispatch = createEventDispatcher();

  $: isDefaultDelay = isEmpty(entitlementMetadata);
  $: defaultDelayText =
    `${formatDurationUnitsToText(
      feedMetadata?.defaultPermissionDelayMonths,
      feedMetadata?.defaultPermissionDelayDays,
      feedMetadata?.defaultPermissionDelayHours,
      feedMetadata?.defaultPermissionDelayMinutes
    )}${feedMetadata?.defaultPermissionCalendarMonthDelay ? ' (Calendar Month Delay)' : ''}` || 'No Delay';
  $: activeDelayText = isDefaultDelay
    ? defaultDelayText
    : `${formatDurationUnitsToText(
        entitlementMetadata?.delayMonths,
        entitlementMetadata?.delayDays,
        entitlementMetadata?.delayHours,
        entitlementMetadata?.delayMinutes
      )}${entitlementMetadata?.calendarMonthDelay ? ' (Calendar Month Delay)' : ''}` || 'No Delay';
</script>

<div class="permission-delay" class:readonly={!isEditable} class:overwritten-delay={!isDefaultDelay}>
  <Button
    portalTooltip
    iconDescription={`${activeDelayText} (${isDefaultDelay ? 'default' : 'overwritten'})`}
    icon={Time16}
    kind="ghost"
    size="small"
    on:click={isEditable
      ? () =>
          dispatch('open-modal', {
            name: 'editDelay',
            feedMetadata,
            entitlementMetadata,
            isDefaultDelay,
            activeDelayText,
            defaultDelayText,
            entitlementId,
            feedName,
          })
      : null}
  />
</div>

<style>
  .permission-delay :global(.bx--btn) {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  .permission-delay :global(.bx--btn:hover) {
    background-color: var(--cds-background-selected-hover);
  }

  .permission-delay.readonly :global(.bx--btn:hover) {
    background-color: transparent;
    cursor: default;
  }

  .permission-delay.overwritten-delay :global(.bx--btn__icon) {
    background-color: var(--cds-support-warning-inverse);
    border-radius: 50%;
  }

  .permission-delay.overwritten-delay :global(path) {
    fill: #161616 !important;
  }
</style>
